import { render } from "./Process.vue?vue&type=template&id=ec9fa682&scoped=true"
import script from "./Process.vue?vue&type=script&lang=js"
export * from "./Process.vue?vue&type=script&lang=js"

import "./Process.vue?vue&type=style&index=0&id=ec9fa682&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec9fa682"]])

export default __exports__